import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-modal-leistung-position-info',
  templateUrl: './modal-leistung-position-info.component.html',
  styles: [
  ]
})
export class ModalLeistungPositionInfoComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
